import { Card, CardContent, Typography, Stack, Box, Button, Divider } from "@mui/material";
import { Home, FileText, ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";

const textColor = "#0d2561";
const itextColor = "#707070";

export function FavoritesWidget() {
  const favoriteActivities = [
    {
      id: 1,
      type: "Property",
      name: "Luxury Condo at Oceanfront",
      activity: "A buyer put an offer.",
      icon: <Home size={20} color="#facc15" />, // yellow-500
    },
    {
      id: 2,
      type: "RFP",
      name: "Commercial Office Space RFP",
      activity: "New comments added.",
      icon: <FileText size={20} color="#facc15" />,
    },
    {
      id: 3,
      type: "Property",
      name: "Historic Downtown Building",
      activity: "Price reduced!",
      icon: <Home size={20} color="#facc15" />,
    },
  ];

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Favorites
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Engage with your favorited properties and RFPs.
        </Typography>

        <Stack spacing={2}>
          {favoriteActivities.map((item) => (
            <Box key={item.id} display="flex" gap={2} alignItems="start">
              <Box mt={0.5}>{item.icon}</Box>
              <Box>
                <Typography variant="body2" fontWeight={500} sx={{ color: textColor }}>
                  {item.name}
                </Typography>
                <Typography variant="caption" sx={{ color: itextColor }}>
                  {item.activity}
                </Typography>
              </Box>
            </Box>
          ))}
        </Stack>

       {/*  <Divider sx={{ my: 2 }} />*/}

        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: textColor, textTransform: "none", fontSize: "0.875rem" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all favorites
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  );
}
